import * as idEndpoints from './id';
import { root, id } from './library';

export const library = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
